import { render, staticRenderFns } from "./yfb.vue?vue&type=template&id=72ca4132&scoped=true"
import script from "./yfb.vue?vue&type=script&lang=js"
export * from "./yfb.vue?vue&type=script&lang=js"
import style0 from "./yfb.vue?vue&type=style&index=0&id=72ca4132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ca4132",
  null
  
)

export default component.exports